export {
  consumeReportsNavigationIntent,
  setReportsNavigationIntent,
  type ReportsNavigationIntent,
} from '../application/reportsNavigationIntent';
